module.exports = __webpack_public_path__ + "static/img/hyzz2.0c2c1f52.png";